import { z } from "zod";

export const mappingColumns = [
  "returnRequestIdColumn",
  "orderIdColumn",
  "orderNameColumn",
  "logisticCodeColumn",
  "skuColumn",
  "barCodeColumn",
  "lineItemIdColumn",
  "quantityColumn",
  "reasonColumn",
] as const;

const ShopImportMappingColumnEnum = z
  .enum(mappingColumns)
  .nullable()
  .optional();

export type ShopImportMappingColumnType = z.infer<
  typeof ShopImportMappingColumnEnum
>;

const ShopImportLoginSchema = z.object({
  user: z.string(),
  password: z.string(),
  host: z.string(),
  path: z.string(),
  port: z.number().nullable().optional(),
});

const CreateOneShopImportSettingsSchema = z.object({
  delimiter: z.string(),
  withHeader: z.boolean(),
  fileToImportFilterRegex: z.string().optional(),
  canImportOrderTwice: z.boolean(),
  rejectRemainingLineItems: z.boolean(),
});

export const ShopImportFormValuesSchema = z.object({
  server: z.object({
    type: z.string(),
    login: ShopImportLoginSchema,
  }),
  options: z.object({
    settings: CreateOneShopImportSettingsSchema,
    exampleFile: z.string().nullable().optional(),
  }),
  mapping: z.array(
    z.object({
      mapTo: ShopImportMappingColumnEnum,
      fieldIndex: z.number(),
      fieldName: z.string(),
      exampleValue: z.string(),
    }),
  ),
});

export type ShopImportFormValues = z.infer<typeof ShopImportFormValuesSchema>;
